/* EulaAppendage.js */

"use strict";
const _ = require("lodash");
const {isValidUrlForStorage} = require("../utils/url-validator");

class EulaCheckAppendage {
    constructor(router, userSession) {
        this._router = router;
        this._userSession = userSession;
    }
    startUp(fullRouteInfo) {
        let routeDestSection = _.get(fullRouteInfo, "newRouteDetails.s", false);
        // Case 25733
        if (!routeDestSection) {
            return true;
        }
        const redirect = _.get(
            fullRouteInfo,
            "newRouteDetails.rd.redirect",
            _.get(fullRouteInfo, "newRouteDetails", false)
        );
        const routeRd = Object.assign({}, {triggeredBy: "Eula", redirect});
        // const routeSR = _.get(fullRouteInfo, "newRouteDetails.sr", false);
        if (
            routeDestSection === "LoginCenter" ||
            routeDestSection === "LogoutCenter" ||
            routeDestSection === "PasswordReset" ||
            routeDestSection.toLowerCase().search("fail") >= 0
        ) {
            return true;
        }
        /*
        if (routeSR && routeSR === "Organization/Licensing") {
            return true;
        }
        */
        let userInfo = this._userSession.getUser();
        let userAuthenticated = this._userSession.isConnectedAndAuthenticated();
        if (!userInfo || !userAuthenticated) {
            if (
                location.href.toLowerCase().search("login") < 0 &&
                location.href.toLowerCase().search("fail") < 0 &&
                location.href.toLowerCase().search("banner") < 0 &&
                location.href.toLowerCase().search("eula") < 0 &&
                location.href.toLowerCase().search("robohelp") < 0 &&
                location.href.toLowerCase().search("passwordreset") < 0 &&
                !window.localStorage.getItem("loadpath", location.href) &&
                isValidUrlForStorage(location.href)
            ) {
                window.localStorage.setItem("loadpath", location.href);
            }
            const token = this._userSession.token || localStorage["Steve.session.token"];
            localStorage.clear();
            location.href = `${window.origin}/session/logout/${token}`;
            return false;
        } else {
            if (userInfo.eulaAcceptTime) {
                return true;
            } else {
                this._router.goTo({app: "GameConsole", s: "Eula", rd: routeRd});
                return false;
            }
        }
    }
}

module.exports = EulaCheckAppendage;
module.exports.$inject = ["$teve.router", "$teve.userSession"];
